import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function SituationPlusQueCritique({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Les erreurs répétées ces derniers mois dans la livraison de vos produits
        et votre absence de réaction sont inacceptables.
      </p>
      <p>
        Je me rends sur le champ à vos bureaux. J'exige de solides explications
        et des solutions rapides.
      </p>
      <MailSignature
        emetteurLogo={SituationPlusQueCritique.metadata.emetteurLogo}
        emetteur={SituationPlusQueCritique.metadata.emetteur}
        emetteurPoste={SituationPlusQueCritique.metadata.emetteurPoste}
        emetteurEntreprise={
          SituationPlusQueCritique.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

SituationPlusQueCritique.metadata = {
  titre: "Situation plus que critique",
  cleMail: "situation_plus_que_critique",
  messageTransfert: false,
  emetteur: "Jean BODIN",
  emetteurPoste: "Directeur Achat",
  emetteurEntreprise: "Société RELAX",
  emetteurLogo: null,
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default SituationPlusQueCritique;
